import AppBar from '@material-ui/core/AppBar'
import Tab from '@material-ui/core/Tab'
import Tabs from '@material-ui/core/Tabs'
import PropTypes from 'prop-types'
import { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useHistory } from 'react-router-dom'
import {
  LOGIN_TAB_CLOSE,
  SIGNUP_TAB_CLOSE,
} from '../../constants/navigationConstants'
import FormContainer from '../Form/FormContainer'
import SignIn from './SignIn/SignIn'
import SignUp from './SignUp/SignUp'
import './login.scss'

function TabPanel(props) {
  const { children, value, index, ...other } = props

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <div className="m-t-30">{children}</div>}
    </div>
  )
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
}

function a11yProps(index) {
  return {
    id: `tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  }
}

const Login = ({ location }) => {
  const history = useHistory()
  const dispatch = useDispatch()
  const redirect = location.search ? location.search.split('=')[1] : ''

  const [value, setValue] = useState(0)

  const { userInfo } = useSelector((state) => state.userLogin)
  const { open: loginOpen } = useSelector((state) => state.loginTab)
  const { open: signupOpen } = useSelector((state) => state.signupTab)

  useEffect(() => {
    if (userInfo) {
      if (redirect !== '') {
        history.push(`${redirect}`)
      } else {
        history.push('/myquality/dashboard')
      }
    }
  }, [userInfo, redirect, history])

  useEffect(() => {
    if (loginOpen) {
      setValue(1)
      dispatch({ type: LOGIN_TAB_CLOSE })
    }
    if (signupOpen) {
      setValue(0)
      dispatch({ type: SIGNUP_TAB_CLOSE })
    }
  }, [loginOpen, signupOpen, dispatch])

  const handleChange = (event, newValue) => {
    setValue(newValue)
  }

  return (
    <div className="login flex">
      <div
        className="bg-image"
        style={{ backgroundImage: "url('/images/login-bg.jpg')" }}
      ></div>
      <FormContainer>
        <AppBar position="static">
          <Tabs
            value={value}
            onChange={handleChange}
            aria-label="simple tabs example"
          >
            <Tab label="Sign up" {...a11yProps(0)} />
            <Tab label="Log in" {...a11yProps(1)} />
          </Tabs>
        </AppBar>
        <TabPanel value={value} index={0}>
          <SignUp location={location} />
        </TabPanel>
        <TabPanel value={value} index={1}>
          <SignIn location={location} />
        </TabPanel>
      </FormContainer>
    </div>
  )
}

export default Login
